
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`La petite histoire`}</em></p>
    <p>{`Des essais sont menés pour combiner l'utilisation avec d'autres produits. Selon
des résultats préliminaires, une dose d'AstraZeneca suivie par une dose de
Comirnaty permet d'obtenir des niveaux d'anticorps élevés. Un essai du même type
a été lancé avec Spoutnik V.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;